import { toast } from "react-toastify";

export const showToast = (message, type = "default") => {
  if (!message) return;
  const notify = toast[type] || toast;
  notify(message);
};
